import { NgModule } from '@angular/core';
import { CustomCheckoutStepsEventBuilder } from './custom-checkout-steps-event.builder';

@NgModule({})
export class CustomCheckoutStepsEventModule {
  // tslint:disable-next-line:variable-name
  constructor(_customCheckoutEventBuilder: CustomCheckoutStepsEventBuilder) {}
}
